import {FormControl} from '@angular/forms';
import {AbstractConstructor, Constructor} from '@angular/material/core/common-behaviors/constructor';

export interface HasWithControlCheck {
  checkControlChanges(): boolean;
}

export type CanWithControlCheck = {
  get fieldControl(): FormControl;
};

export type HasWithControlCheckCtor = Constructor<HasWithControlCheck> & AbstractConstructor<HasWithControlCheck>;

export function mixinHasControlCheck<T extends Constructor<CanWithControlCheck> | AbstractConstructor<CanWithControlCheck>>(
  base: T
): HasWithControlCheckCtor & T {
  return class extends base {
    private oldTouched = null;
    private oldValue = null;
    private oldDisabled = null;
    private oldErrors = null;

    checkControlChanges(): boolean {
      const control = super.fieldControl;

      if (control?.touched !== this.oldTouched) {
        this.oldTouched = control.touched;
        return true;
      }
      if (control?.disabled !== this.oldDisabled) {
        this.oldDisabled = control?.disabled;
        return true;
      }
      if (control?.value && control.value !== this.oldValue) {
        this.oldValue = control.value;
        return true;
      }
      if (JSON.stringify(control?.errors) !== JSON.stringify(this.oldErrors)) {
        this.oldErrors = control.errors;
        return true;
      }
      return false;
    }
  };
}
const defaultClass = class {};
export type FormControlAccessorFn = () => FormControl;
// eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/ban-types
type WithControlCheckFn = <T extends Constructor<object> | AbstractConstructor<object> = typeof defaultClass>(
  formControlAccessor: FormControlAccessorFn,
  base?: T
) => HasWithControlCheckCtor & T;

export const WithControlCheck: WithControlCheckFn = (formControlAccessor: FormControlAccessorFn, base?) =>
  (base
    ? mixinHasControlCheck(
        class extends base {
          get fieldControl() {
            return formControlAccessor.bind(this)();
          }
        }
      )
    : mixinHasControlCheck(
        class {
          get fieldControl() {
            return formControlAccessor.bind(this)();
          }
        }
      )) as unknown as any;
